import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  className?: string;
};
export function SectionLabel({
  children,
  className = ''
}: SectionLabelProps) {
  return <p className={`font-display text-[10px] sm:text-xs font-semibold uppercase tracking-mega text-violeta-300 ${className}`} data-id="element-203" data-mp="1cpc01l4lr4ws">
      {children}
    </p>;
}